var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.campaigns && _vm.campaigns.length)?_c('div',{staticClass:"campaigns-container"},[_c('h3',{staticClass:"subheadline1 black-color"},[_vm._v("Popular Campaigns on CrowdBlue")]),_vm._v(" "),_c('CpImagesCarousel',{attrs:{"carouselItems":_vm.campaigns}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }